import React, { useEffect, useRef, useState } from 'react';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { DisplayS, HeadingSBold, BodySBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import { ECommerceService } from 'services/eCommerce/eCommerce';
import { isEnabled } from 'utils/packages/packageState';
import { SingleCustomerProduct } from 'utils/api/models/products/singleCustomerProduct';
import { SinglePackage } from 'utils/api/models/numbers/singlePackage';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/detailsStyle';
import { makeStyles } from '@material-ui/core/styles';

// @ts-ignore
const useStyles = makeStyles(styles);

export interface IMobileInternetPlanCardProps {
	isPostpaid: boolean;
	phoneNumber: string;
	accountType: string;
	billingType: string;
	customerProducts: SingleCustomerProduct[];
}

const MobileInternetPlanCard = ({
	phoneNumber,
	accountType,
	billingType,
	customerProducts,
}: IMobileInternetPlanCardProps) => {
	const [mobileDataPlan, setMobileDataPlan] = useState<SinglePackage | null>(null);
	const classes = useStyles();
	const showMobileDataPlan: boolean = !!mobileDataPlan;
	const showMobileDataPlanPrice: boolean = !!mobileDataPlan?.price && !!mobileDataPlan?.priceCurrency;
	const isMounted = useRef(true);

	useEffect(() => {
		ECommerceService.getPackages('MOBILE_INTERNET_PLANS', 'POSTPAID').subscribe(({ packages }) => {
			const enabledPackages = packages.filter((singlePackage: SinglePackage) =>
				isEnabled(customerProducts, singlePackage)
			);
			if (enabledPackages.length > 0 && isMounted.current) {
				setMobileDataPlan(enabledPackages[0]);
			}
		});
	}, [phoneNumber, accountType, billingType, customerProducts]);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	return (
		<ConditionalRender
			show={showMobileDataPlan}
			onTrue={() => (
				<GridItem xs={12} md={6}>
					<Card className={classes.bundleCard}>
						<CardBody className={classes.cardBody}>
							<HeadingSBold>{translate('number.services.mobile.internet.plan')}</HeadingSBold>
							<DisplayS color="secondary-light" disableMargin={!showMobileDataPlanPrice}>
								{mobileDataPlan?.name}
							</DisplayS>
							<ConditionalRender
								show={showMobileDataPlanPrice}
								onTrue={() => (
									<div>
										<BodySBold color="primary-light" disableMargin>
											<>
												{translate('number.details.monthly.subscription')}{' '}
												{mobileDataPlan?.price} {mobileDataPlan?.priceCurrency}
											</>
										</BodySBold>
									</div>
								)}
							/>
						</CardBody>
					</Card>
				</GridItem>
			)}
		/>
	);
};

export default MobileInternetPlanCard;
